const comments = [
  { id: 1, name: '影迷小陈', time: '2小时前', content: '天美麻花星空影视真的太棒了！电影在线观看特别流畅，高清画质一点都不缓冲，比很多收费平台还稳定，强烈推荐给喜欢看电影的朋友！', rating: 5 },
  { id: 2, name: '追剧达人', time: '5小时前', content: '在这里追完了整部电视剧免费观看，资源更新速度超快，而且综艺节目也很全，每天下班回来第一件事就是打开天美麻花。', rating: 5 },
  { id: 3, name: '电影发烧友', time: '昨天', content: '91电影视频和麻豆影视在线观看资源整合得很好，分类清晰，找片方便。画面清晰度没得说，必须给好评！', rating: 4 },
  { id: 4, name: '休闲观影人', time: '昨天', content: '用了很多影视平台，天美麻花星空影视免费观看是体验最好的一个。最新影视更新及时，不卡顿不缓冲，观影体验满分。', rating: 5 },
  { id: 5, name: '资深剧迷', time: '2天前', content: '高清免费不缓冲确实名不虚传！各种题材的影视视频都有覆盖，从经典老片到最新院线，想看的基本都能找到。', rating: 5 },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              观众热评
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              来自天美麻花星空影视免费观看用户的真实反馈
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {comments.map((comment) => (
              <article key={comment.id} className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: comment.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-400 text-sm w-4 h-4 flex items-center justify-center"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  &ldquo;{comment.content}&rdquo;
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-xs font-medium text-primary-600">{comment.name[0]}</span>
                    </div>
                    <span className="text-sm font-medium text-foreground-800">{comment.name}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}